import React from "react";
import Hero from "./Hero";
import AboutBook from "./AboutBook";
import WhyThisBook from "./WhyThisBook";
import MindIsKing from "./MindIsKing";
import FormatPricing from "./FormatPricing";
import MeetAuthor from "./MeetAuthor";
import ClientReviews from "./ClientReviews";
import Contact from "./Contact";
import Gallery from "../home/Gallery";

const NewHero = () => {
  return (
    <>
      <Hero />
      <AboutBook />
      <WhyThisBook />
      <MindIsKing />
      <FormatPricing />
      <MeetAuthor />
      <Gallery />
      <ClientReviews />
      <Contact />
    </>
  );
};

export default NewHero;
